import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accountmaster-menu',
  templateUrl: './accountmaster-menu.component.html',
  styleUrls: ['./accountmaster-menu.component.css']
})
export class AccountmasterMenuComponent implements OnInit {

  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Master Account')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/master-account/accountmaster-menu/accountmaster-menu.component.ts